module.exports = __webpack_public_path__ + "static/locathah-1-ade0b09d422e7a8465c75748eb7dc6e3.png";